import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    previews: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      gap: "24px",
      flexWrap: "wrap",
    },
    preview: {
      position: "relative",
    },
    thumbnail: {
      width: "150px",
      display: "block",
    },
  },
  { name: "FileUpload" },
);

export { useStyles };
